export default __webpack_public_path__ + "4a5647b4dacbae740e551eb6a3abb3bc.jpg";